/**
 * Shippings service: CRUD and list by product_supplier_id.
 */
import axios from 'axios';
import { authHeaders } from './apiAuth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Get shippings, optionally filtered by product_supplier_id.
 * @param {string} accessToken - User's JWT
 * @param {{ product_supplier_id?: number }} params - Optional filter
 * @returns {Promise<{ success: boolean, shippings: Array }>}
 */
export const getShippings = async (accessToken, { product_supplier_id } = {}) => {
  const params = {};
  if (product_supplier_id != null) params.product_supplier_id = product_supplier_id;
  const response = await axios.get(`${API_BASE_URL}/api/shippings`, {
    headers: authHeaders(accessToken),
    params
  });
  return response.data;
};

/**
 * Get one shipping by id.
 * @param {string} accessToken - User's JWT
 * @param {number} shippingId - shippings.id
 * @returns {Promise<{ success: boolean, shipping?: Object }>}
 */
export const getShipping = async (accessToken, shippingId) => {
  const response = await axios.get(`${API_BASE_URL}/api/shippings/${shippingId}`, {
    headers: authHeaders(accessToken)
  });
  return response.data;
};

/**
 * Create a shipping. product_supplier_id is required.
 * @param {string} accessToken - User's JWT
 * @param {Object} data - ShippingCreate fields
 * @returns {Promise<{ success: boolean, shipping?: Object }>}
 */
export const createShipping = async (accessToken, data) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/shippings`,
    { shipping: data },
    { headers: authHeaders(accessToken) }
  );
  return response.data;
};

/**
 * Update a shipping by id.
 * @param {string} accessToken - User's JWT
 * @param {number} shippingId - shippings.id
 * @param {Object} data - Partial ShippingUpdate fields
 * @returns {Promise<{ success: boolean, shipping?: Object }>}
 */
export const updateShipping = async (accessToken, shippingId, data) => {
  const response = await axios.put(
    `${API_BASE_URL}/api/shippings/${shippingId}`,
    { shipping: data },
    { headers: authHeaders(accessToken) }
  );
  return response.data;
};

/**
 * Delete a shipping by id.
 * @param {string} accessToken - User's JWT
 * @param {number} shippingId - shippings.id
 * @returns {Promise<{ success: boolean }>}
 */
export const deleteShipping = async (accessToken, shippingId) => {
  const response = await axios.delete(
    `${API_BASE_URL}/api/shippings/${shippingId}`,
    { headers: authHeaders(accessToken) }
  );
  return response.data;
};
